import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';

import Cart from '../components/Cart';

import connect from '../store/connect';
import SlideOutContainer from './SlideOutContainer';
import { setViewstate } from '../actions/actionCreators';
import { color } from '../styles/helpers/variables';

class CartWrapper extends Component {
  constructor(props) {
    super(props);
    this.toggleCart = this.toggleCart.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.cart.get('cart', List()).isEmpty()) {
      this.toggleCart(false);
    }
  }

  toggleCart(bool) {
    if (this.props.cart.get('cart', List()).isEmpty() || !bool) {
      this.props.setViewstate('cartActive', false);
    } else {
      this.props.setViewstate('cartActive', !this.props.viewstate.get('cartActive'));
    }
  }

  render() {
    return (
      <SlideOutContainer
        toggleModal={this.toggleCart}
        active={this.props.viewstate.get('cartActive')}
        bgColor={color.lightGrey}
        noPadding
        small
      >
        <Cart />
      </SlideOutContainer>
    );
  }
}

CartWrapper.defaultProps = {
  cart: Map(),
  viewstate: Map()
};

CartWrapper.propTypes = {
  setViewstate: PropTypes.func.isRequired,
  cart: PropTypes.instanceOf(Map),
  viewstate: PropTypes.instanceOf(Map)
};

export default connect(CartWrapper, { setViewstate }, store => ({
  cart: store.cart,
  viewstate: store.viewstate
}));



// WEBPACK FOOTER //
// ./src/components/CartWrapper.js